import React, { FC, useContext, useMemo } from 'react';

import { useQuery } from '@apollo/client';
import { Button, InfoBlock } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';

import { AuthContext } from '../../constants';
import { USER_CLUBS } from '../../schema';
import { IUserClubsResponse } from '../../types';
import { IErrorWorkShiftProps } from '../interfaces';
import s from './ErrorWorkShift.module.scss';

const ErrorWorkShift: FC<IErrorWorkShiftProps> = ({
  club,
  returnToClubSelect,
}) => {
  const { t } = useContext(LocalizationContext);

  const {
    data: { tokens },
  } = useContext(AuthContext);

  const { data: { userClubs } = {} } = useQuery<IUserClubsResponse>(
    USER_CLUBS,
    {
      fetchPolicy: 'no-cache',
      skip: Boolean(club),
    }
  );

  const currentClub = useMemo(() => {
    const encodedToken = atob(tokens?.access_token?.split('.')[1] ?? '');
    const clubId = encodedToken ? JSON.parse(encodedToken)?.company_id : null;

    return userClubs?.find((club) => club.id === clubId) ?? club;
  }, [userClubs, tokens?.access_token, club]);

  const operator = useMemo<string>(() => {
    if (!currentClub) return '';

    if (currentClub.operatorFirstName && currentClub.operatorLastName)
      return `${currentClub.operatorLastName} ${currentClub.operatorFirstName[0]}.`;
    else if (currentClub.operatorLastName) return currentClub.operatorLastName;
    else if (currentClub.operatorFirstName)
      return currentClub.operatorFirstName;
    else return '';
  }, [currentClub]);

  return (
    <div className={s.container}>
      <h2 className={s.title}>{t('workShifts.error.title')}</h2>
      <InfoBlock
        title={t('workShifts.error.info.title')}
        message={t('workShifts.error.info.message')}
        color="orange"
        iconName="ExclamationIcon"
      />
      {operator !== '' && (
        <div className={s.info}>
          <span className={s.title}>{operator}</span>
          <span className={s.subtitle}>
            {t('workShifts.error.operator.subtitle')}
          </span>
        </div>
      )}
      <Button
        type="button"
        variant="ghost"
        onClick={() => returnToClubSelect()}
        className={s['select-club']}
      >
        {t('clubs.change')}
      </Button>
    </div>
  );
};

export default ErrorWorkShift;
